import { SliderComponent } from '@webentorCore/_slider';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.b-reviews-slider .js-slider');

  sliders.forEach((element) => {
    const dataSlider = element.getAttribute('data-slider');
    const params = JSON.parse(dataSlider || '{}');

    new SliderComponent(element, params);
  });
});
